export const isTenantWalletEnabled = (tenant: any): boolean =>
    tenant?.walletEnabled === true;

export const isTenantVisitorPassDelegationEnabled = (tenant: any): boolean =>
    isTenantWalletEnabled(tenant) && tenant?.visitorPassDelegationEnabled === true;
